import React, { useState } from 'react';
import styles from './DracmaPurchase.module.css';
import profileStyles from './Profile.module.css';
import { useTranslation } from 'react-i18next';

const DracmaPurchase = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handlePurchase = async () => {
    setLoading(true);
    setMessage(null); // Limpa mensagens anteriores

    // Simula a chamada à API
    try {
      // Simulando um atraso de rede
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Simula uma resposta de sucesso ou erro aleatoriamente
      const success = Math.random() > 0.2; // 80% de chance de sucesso

      if (success) {
        setMessage({ type: 'success', text: t('purchaseSuccess') });
      } else {
        setMessage({ type: 'error', text: t('purchaseError') });
      }
    } catch (error) {
      setMessage({ type: 'error', text: t('unexpectedError') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('buyDracmas')}</h2>
      <div className={styles.formGroup}>
        <label htmlFor="amount">{t('amountUSD')}:</label>
        <input
          type="number"
          id="amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder={t('enterAmountUSD')}
          disabled={loading}
          className={styles.input}
        />
      </div>
      <button 
        onClick={handlePurchase} 
        disabled={loading} 
        className={`${profileStyles['button-base']} ${profileStyles['button-primary']}`}
      >
        {loading ? t('processing') : t('buyDracmasButton')}
      </button>

      {message && (
        <div className={message.type === 'success' ? styles['success-message'] : styles['error-message']}>
          {message.text}
        </div>
      )}
    </div>
  );
};

export default DracmaPurchase;
